import React from 'react';
import { isPublicTagHost } from '@/lib/publicTagHost';
import { optionRules, setMatOpts, useMatOpts, useMatRules, pieceForcedOpts } from '@/lib/tagMatHandling';

// Tick boxes for the super-admin material options (e.g. "Show Dak Wt") for this print / list / sale.
// `pieces` (raw docs): notes pieces that always get an option because they were made for its customer.
export function TagMatOptToggles({ testid = 'tag-mat-opts', className = '', pieces = [] }) {
  useMatRules();
  const ticked = useMatOpts();
  const list = isPublicTagHost() ? optionRules() : [];
  if (!list.length) return null;
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`} data-testid={testid}>
      {list.map((r) => {
        const on = ticked.includes(r.id);
        const forced = on ? 0 : pieces.filter((p) => pieceForcedOpts(p).includes(r.id)).length;
        return (
          <React.Fragment key={r.id}>
            <label className={`inline-flex h-8 cursor-pointer items-center gap-1.5 rounded-lg border px-2.5 text-xs font-semibold transition-colors ${on ? 'text-white' : 'border-border bg-card text-foreground hover:bg-secondary'}`}
              style={on ? { background: r.color, borderColor: r.color } : undefined} data-testid={`${testid}-${r.id}`}>
              <input type="checkbox" checked={on} onChange={(e) => setMatOpts(e.target.checked ? [...ticked, r.id] : ticked.filter((x) => x !== r.id))} className="h-3.5 w-3.5" style={{ accentColor: r.color }} data-testid={`${testid}-${r.id}-checkbox`} />
              {r.option.label}
            </label>
            {forced ? <span className="text-[11px] font-medium" style={{ color: r.color }} data-testid={`${testid}-${r.id}-forced`}>{forced === pieces.length && pieces.length === 1 ? 'This piece' : `${forced} piece${forced === 1 ? '' : 's'}`} always {forced === 1 ? 'shows' : 'show'} {r.name} (made for {forced === 1 ? 'its' : 'their'} customer)</span> : null}
          </React.Fragment>
        );
      })}
    </div>
  );
}
